<template>
    <div id="edition">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
        <el-breadcrumb-item>版本管理</el-breadcrumb-item>
      </el-breadcrumb>
      <p class="title">版本管理</p>
      <div v-if="currentData.length == 0 && onlineData.length == 0 && historyData.length == 0" style="text-align: center">暂无版本信息</div>
      <div class="editionContainer" v-else>
        <div class="editionList" v-if="currentData.length != 0">
          <p class="font-size-p">当前版本</p>
          <div>
            <template>
              <el-table
                v-loading="loading"
                :data="currentData"
                style="width: 100%">
                <el-table-column
                  align="center"
                  label="技能名称">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_name">{{  scope.row.skill_name }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="版本号">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_version">{{  scope.row.skill_version }}</span>
                    <span v-else>暂无</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="技能类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.open_skill_type == 0">原始技能</span>
                    <span v-else-if="scope.row.open_skill_type == 1">自定义</span>
                    <span v-else-if="scope.row.open_skill_type == 2">智能家居</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.audit_status == 0">开发中</span>
                    <span v-else-if="scope.row.audit_status == 1">拒绝审核</span>
                    <span v-else-if="scope.row.audit_status == 2">通过审核</span>
                    <span v-else-if="scope.row.audit_status == 3">审核中</span>
                    <span v-else-if="scope.row.audit_status == 4">拒绝上线</span>
                    <span v-else-if="scope.row.audit_status == 5">已上线</span>
                    <span v-else-if="scope.row.audit_status == 6">已下线</span>
                    <span v-else-if="scope.row.audit_status == 7">已删除</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="创建时间">
                  <template slot-scope="scope">
                    <span v-if="scope.row.created_at">{{  scope.row.created_at }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作">
                  <template slot-scope="scope">
                    <div v-if="scope.row.audit_status != 3">
                      <el-button  type="text"  @click="toEditSkill(scope.row)" size="small">编辑</el-button>
                      <el-button @click="delCurrent(scope.row)" type="text" size="small">删除</el-button>
                    </div>
                    <div v-else>
                      <el-button @click="returnCurrent(scope.row)" type="text" size="small">撤回</el-button>
                    </div>
                    <!--<el-button v-if="scope.row.audit_status == 5" type="warning" size="small"></el-button>-->
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>

        </div>
        <div class="editionList" v-if="onlineData.length != 0">
          <p class="font-size-p">线上版本</p>
          <div>
            <template>
              <el-table v-if="onlineData"
                        :data="onlineData"
                        v-loading="loading"
                        style="width: 100%">
                <el-table-column
                  align="center"
                  label="技能名称">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_name">{{  scope.row.skill_name }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="版本号">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_version">{{  scope.row.skill_version }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="技能类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.open_skill_type == 0">原始技能</span>
                    <span v-else-if="scope.row.open_skill_type == 1">自定义</span>
                    <span v-else-if="scope.row.open_skill_type == 2">智能家居</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.audit_status == 0">未审核</span>
                    <span v-else-if="scope.row.audit_status == 1">拒绝审核</span>
                    <span v-else-if="scope.row.audit_status == 2">通过审核</span>
                    <span v-else-if="scope.row.audit_status == 3">申请上线</span>
                    <span v-else-if="scope.row.audit_status == 4">拒绝上线</span>
                    <span v-else-if="scope.row.audit_status == 5">已上线</span>
                    <span v-else-if="scope.row.audit_status == 6">已下线</span>
                    <span v-else-if="scope.row.audit_status == 7">已删除</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="创建时间">
                  <template slot-scope="scope">
                    <span v-if="scope.row.created_at">{{  scope.row.created_at }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" :disabled="scope.row.upgrade == 0 ? true:false" size="small" @click="toUpdataSkill(scope.row)">更新</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>

        </div>
        <div class="editionList" v-if="historyData.length != 0">
          <p class="font-size-p">历史版本</p>
          <div>
            <template>
              <el-table v-if="historyData"
                        :data="historyData"
                        v-loading="loading"
                        style="width: 100%">
                <el-table-column
                  align="center"
                  label="技能名称">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_name">{{  scope.row.skill_name }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="版本号">
                  <template slot-scope="scope">
                    <span v-if="scope.row.skill_version">{{  scope.row.skill_version }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="技能类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.open_skill_type == 0">原始技能</span>
                    <span v-else-if="scope.row.open_skill_type == 1">自定义</span>
                    <span v-else-if="scope.row.open_skill_type == 2">智能家居</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="状态">
                  <template slot-scope="scope">
                    <!--<span v-if="scope.row.audit_status == 0">未审核</span>
                    <span v-else-if="scope.row.audit_status == 1">拒绝审核</span>
                    <span v-else-if="scope.row.audit_status == 2">通过审核</span>
                    <span v-else-if="scope.row.audit_status == 3">申请上线</span>
                    <span v-else-if="scope.row.audit_status == 4">拒绝上线</span>
                    <span v-else-if="scope.row.audit_status == 5">已上线</span>
                    <span v-else-if="scope.row.audit_status == 6">已下线</span>
                    <span v-else-if="scope.row.audit_status == 7">已删除</span>-->
                    <span>历史版本</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="创建时间">
                  <template slot-scope="scope">
                    <span v-if="scope.row.created_at">{{  scope.row.created_at }}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delHistory(scope.row)" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>

      </div>
    </div>
</template>
<script>
  import qs from 'qs'
  import {getUserId, versionApi, delVersionApi, upDataVersionApi, delCurrentApi, returnCurrentApi} from '@/api'
  import config from '@/config/index'
    export default {
        data() {
            return {
              loading:true,
              user_id: '',
              skill_id:'',
              tableData: [

              ],
              currentData:[],
              onlineData:[],
              historyData:[],
            }
        },
      created() {
        this.getUserId()
      },
        methods: {
          async getUserId () {//获取用户id skillId
            let res = await getUserId()
            if (res.data.code == 200) {
              this.user_id = res.data.data.id
              this.skill_id = this.$route.query.skillId;
              this.versionList()
            }
          },
          async versionList (fun) {
            let data = {
              user_id: this.user_id,
              skill_id: this.skill_id
            }
            let res = await versionApi(qs.stringify({user_id: this.user_id,skill_id: this.$route.query.skillId,online:this.$route.query.online}))
            if(res.data.code == 200){
              this.loading = false;
              if(res.data.data.current.id){
                this.currentData.push(res.data.data.current)
              }else if(typeof res.data.data.current == 'array'){
                this.currentData = res.data.data.current;
              }else{
                this.currentData = [];
              }
              if(res.data.data.online.id){
                this.onlineData.push(res.data.data.online)
              }else if(typeof res.data.data.online == 'array'){
                this.onlineData = res.data.data.online;
              }else{
                this.onlineData = [];
              }
              if(res.data.data.history ==null){
                this.historyData.push(res.data.data.history)
              }else if(typeof res.data.data.history == 'array'){
                this.historyData = res.data.data.history;
              }else{
                this.historyData = [];
              }
              this.historyData = res.data.data.history;
            }
            if(typeof fun == 'function'){
              fun();
            }
          },
          async toUpdataSkill(row){
            let data_up = {
              'dev_id': row.user_id,
              'skill_id': this.skill_id,
             /* 'skill_version': row.skill_version,
              'open_skill_type': row.open_skill_type,
              'chinese_name': row.chinese_name,
              'domain': row.domain,
              'category': row.category,
              'skill_icon_url': row.skill_icon_url,
              'skill_intro': row.skill_intro,
              'update_intro': row.update_intro,*/
            }
            this.loading = true;
            let res = await upDataVersionApi(qs.stringify({'dev_id': this.user_id,'skill_id': this.skill_id}))
            if(res.data.code == 200){
              //this.$router.push('/updateSkill?&skillId='+this.skill_id+'&online=1')
              this.currentData=[]
              this. onlineData=[]
              this.historyData=[]
              this.versionList()
              //window.location.reload();
            }else{
              this.loading = false;
              this.$message({message: res.data.errors.data, type: 'error'})
            }
          },//更新
          toEditSkill(row){
            localStorage.setItem('onlineFlag', '0');
            window.location.href = '/updateSkill?&skillId='+this.skill_id+'&online='+row.audit_status
            // this.$router.push('/updateSkill?&skillId='+this.skill_id+'&online='+row.audit_status)
          },//编辑
          delCurrent (row) {
            this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let data_del = {
                'dev_id': this.user_id,
                'skill_id': this.skill_id,
                'version': row.skill_version ?row.skill_version:'v0',
                'online': row.audit_status
              }
              delCurrentApi(this.skill_id,qs.stringify(data_del)).then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!',
                  });
                  this.currentData=[]
                  this.onlineData=[]
                  this.historyData=[]
                  this.versionList( () =>{
                    if(this.currentData=='' && this.onlineData=='' && this.historyData==''){
                      this.$router.push('/skillList');
                    }
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: '删除失败!'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
          },
          delHistory(row){
            this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let data_del = {
                'dev_id': this.user_id,
                'skill_id': this.skill_id,
                'version': row.skill_version
              }
              delVersionApi(qs.stringify(data_del)).then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.currentData=[]
                  this. onlineData=[]
                  this.historyData=[]
                  this.versionList();
                } else {
                  this.$message({
                    type: 'error',
                    message: '删除失败!'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
          },
          returnCurrent(){
            this.$confirm('此操作将撤回审核版本, 是否继续?', '提示', {
              confirmButtonText: '撤回',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              returnCurrentApi(qs.stringify({'skill_id':this.skill_id})).then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '撤回成功!'
                  })
                  this.currentData=[]
                  this. onlineData=[]
                  this.historyData=[]
                  this.versionList()
                  localStorage.setItem('onlineFlag', '0')
                } else {
                  this.$message({
                    type: 'error',
                    message: '撤回失败!'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消撤回'
              })
            })
          }
        }
    }
</script>
<style  rel="stylesheet/scss" lang="scss" scoped>
  #edition{
    background:#fff;
    padding-top:0;
    min-height: 700px;
    .title{
      height:64px;
      line-height:64px;
      padding-left:30px;
      font-weight: 900;
      font-size: 18px;
      color:#2e4d79;
      border-bottom:1px solid #f5f5f5;
      border-left:2px solid #010202;
    }
    .editionContainer{
      .editionList{
        padding:20px 30px;
        p{
          color:#767676;
          margin-bottom: 15px;
          font-weight: 500;
        }
      }
    }
    .font-size-p{
      font-size: 16px;

    }
    /*.edition_cx{*/
      /*width: 44px;*/
      /*height:32px;*/
      /*position: relative;*/
      /*top:2px;*/
    /*}*/
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/Edition.vue